// extracted by mini-css-extract-plugin
module.exports = {"app":"Shell_app__xMSTE","page":"Shell_page__1ig2F"};